import React from "react";
import { Stack } from "@mui/system";

import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";


export default function BarcarenaLogistica(){

  return(

    <>
    <Helmet title="Barcarena Logística - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="BARCARENA LOGÍSTICA" link1={"Projetos/ "} link2={"BARCARENA-LOGÍSTICA"} />
      <section id="context">
        <div className="container">

        <div className="context-bg"></div>

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Barcarena Logística</h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Prestação de serviços de Apoio Operacional, Técnico e Administrativo na Refinaria e Área Portuária da Hydro em Barcarena – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Informações do Projeto</h2>
                <ul
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <li><strong>Cliente: </strong> Hydro</li>
                  <li><strong>Cidade: </strong> Barcarena - Pará </li>
                  <li><strong>Ano: </strong> 2018 </li>
                  <li><strong>Segmento: </strong> Facilities
 </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />


      <Ouvidoria/>
    </>
  )
}